export const MAGNET_DISABLED_MSG = {
  size: "This size isn't available for magnets",
  silhouette: "This shape isn't available for magnets",
};

export const DISABLED_MSG = {
  type: 'This item is out of stock and cannot be shipped.',
  medium: "This type isn't available for this card",
  size: "This size isn't available for the current card type",
  'paper-type': {
    pearlized: 'This paper type is currently out of stock.',
    default: "This paper type isn't available with your current selections",
  },
  silhouette: `This shape isn't available with your current selections`,
};

export const BASE_PAPER_SHAPES = ['square', 'rounded'];
export const ALL_PAPER_SHAPES = ['square', 'rounded', 'scalloped', 'arch', 'ticket', 'diamond'];

export const THICK_PAPER_TYPES = ['double-thick', 'triple-thick'];
